import { useState } from "react";
import Navbar from "../include/Navbar";
import img from "../assets/img/Standard-Internal-Circlips-Metric-diagram.png";

export default function CompressionSpringPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    tel: "",
    requirements: "",
    wireDia: "",
    outsideDia: "",
    freeLength: "",
    quantity: "",
    file: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="flex flex-col md:flex-row p-6 bg-gray-100 min-h-screen mt-20 p-6">
        {/* Left Section */}
        <div className="md:w-2/3 p-6 bg-white shadow-lg rounded-lg">
          <h2 className="text-2xl font-bold">Bespoke compression springs.</h2>
          <p className="mt-4 text-gray-600">
            Bespoke compression springs available in a wide variety of materials
            and sizes. The most common being carbon steel or stainless steel.
            These springs can be open or closed coil depending on required
            design parameters. Let us help you with the design and manufacturing
            of your custom compression springs.
          </p>
          <p className="mt-4 text-lg font-semibold italic text-red-600">
            No order is too small or too large!
          </p>
          <img
            // src="/img/spring.jpg"
            src={img}
            alt="Compression Springs"
            className="mt-4 w-full"
          />
        </div>

        {/* Right Section - Contact Form */}
        <div className="md:w-1/3 p-6 bg-white shadow-lg rounded-lg ml-0 md:ml-6 mt-6 md:mt-0">
          <h3 className="text-xl font-bold">Compression Spring Contact Form</h3>
          <p className="text-sm text-gray-600">
            Alternatively you can email us at{" "}
            <a href="mailto:info@supersprings.co.in" className="text-red-600">
                info@supersprings.co.in
            </a>
          </p>

          <form className="mt-4" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name*"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-2 border rounded mt-2"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="E-mail*"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-2 border rounded mt-2"
              required
            />
            <input
              type="tel"
              name="tel"
              placeholder="Tel"
              value={formData.tel}
              onChange={handleChange}
              className="w-full p-2 border rounded mt-2"
            />
            <textarea
              name="requirements"
              placeholder="Special Requirements"
              value={formData.requirements}
              onChange={handleChange}
              className="w-full p-2 border rounded mt-2"
              rows="3"
            ></textarea>

            <h4 className="text-lg font-bold mt-4">Specifications</h4>
            <input
              type="text"
              name="wireDia"
              placeholder="Wire Dia (mm)"
              value={formData.wireDia}
              onChange={handleChange}
              className="w-full p-2 border rounded mt-2"
            />
            <input
              type="text"
              name="outsideDia"
              placeholder="Outside Dia (mm)"
              value={formData.outsideDia}
              onChange={handleChange}
              className="w-full p-2 border rounded mt-2"
            />
            <input
              type="text"
              name="freeLength"
              placeholder="Free Length (mm)"
              value={formData.freeLength}
              onChange={handleChange}
              className="w-full p-2 border rounded mt-2"
            />
            <input
              type="text"
              name="quantity"
              placeholder="Quantity required"
              value={formData.quantity}
              onChange={handleChange}
              className="w-full p-2 border rounded mt-2"
            />

            <h4 className="text-lg font-bold mt-4">File Upload</h4>
            <input
              type="file"
              onChange={handleFileChange}
              className="w-full p-2 border rounded mt-2"
            />

            <button
              type="submit"
              className="w-full mt-4 p-2 bg-red-600 text-white font-bold rounded"
            >
              Request Quote
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
